import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="site-builder--toast"
export default class extends Controller {
  static targets = ["title", "body"];

  show(title, body) {
    this.title(title);
    this.body(body);

    if (!this.element.classList.contains("show")) {
      this.element.classList.add("show");
    }

    setTimeout(() => {
      this.hide();
    }, 10000);
  }

  hide() {
    if (this.element.classList.contains("show")) {
      this.element.classList.remove("show");
    }
  }

  title(value) {
    this.titleTarget.innerHTML = value;
  }

  body(value) {
    this.bodyTarget.innerHTML = value;
  }
}
